import useTranslation from '@space-core/hooks/useTranslation'
import { customMedia } from '@space-core/styles'
import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import ErrorState from '@space-shell/modules/home/components/errorState'

import { Wrapper as ErrorPopupWrapper } from '@space-shell/modules/home/components/errorState/errorPopup'
import styled from 'styled-components'

import LoaderList from '../showcaseLoader/loaderList'

type ShowcaseErrorStateProps = {
  onTryAgain: () => void
  orientation?: ShowcaseOrientation
  loaderTitle?: boolean
}

const Wrapper = styled.div<{ $loaderTitle: boolean }>`
  margin-bottom: calc(var(--spacer-8) * 2);

  ${customMedia.lessThan('md')`
    margin-bottom: var(--spacer-8);
  `}

  ${ErrorPopupWrapper} {
    ${({ $loaderTitle }) => $loaderTitle && `top: 58%`};
  }
`

const ShowcaseErrorState = ({
  onTryAgain,
  orientation = ShowcaseOrientation.HORIZONTAL,
  loaderTitle = false
}: ShowcaseErrorStateProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper $loaderTitle={loaderTitle}>
      <ErrorState
        onTryAgain={onTryAgain}
        textButton={t('error_state.text_button')}
        title={t('home.error_state.title.general')}
        description={t('home.error_state.description')}
        contentLoader={<LoaderList orientation={orientation} title={loaderTitle} />}
      />
    </Wrapper>
  )
}

export default ShowcaseErrorState
